import React, { FC } from 'react';

const Divider: FC = () => (
  <div className='w-2/4 flex items-center mb-6'>
    <hr className='flex-grow border-gray-300' />
    <span className='mx-2 text-black'>OR</span>
    <hr className='flex-grow border-gray-300' />
  </div>
);

export default Divider;
